import { render } from "./PointPage.vue?vue&type=template&id=66b8be66&scoped=true"
import script from "./PointPage.vue?vue&type=script&lang=js"
export * from "./PointPage.vue?vue&type=script&lang=js"

import "./PointPage.vue?vue&type=style&index=0&id=66b8be66&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66b8be66"]])

export default __exports__